import type { ReactNode } from "react";

export function Empty({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="rounded-2xl border border-dashed border-[var(--border-strong)] bg-white px-6 py-14 text-center">
      <span className="brand-mark mx-auto">R</span>
      <h3 className="mt-3 text-xl font-semibold tracking-tight">{title}</h3>
      <p className="mx-auto mt-1 max-w-md text-sm text-[var(--text-secondary)]">
        {description}
      </p>
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Loading() {
  return (
    <Empty
      title="Loading workspace…"
      description="Reading the latest organisation state from RAQOZ."
    />
  );
}

export function ErrorState({ message }: { message: string }) {
  return <Empty title="Unable to load this view" description={message} />;
}
